
export const tagConstants = {
    LIST_TAGS_REQUEST: 'LIST_TAGS_REQUEST',
    LIST_TAGS_SUCCESS: 'LIST_TAGS_SUCCESS',
    LIST_TAGS_FAILURE: 'LIST_TAGS_FAILURE',
    CLEAR_TAGS: 'CLEAR_TAGS',
}